@if(isLoading()){
<app-preloader></app-preloader>
}
<app-notifications></app-notifications>

<button
  class="tertiary"
  [ngClass]="{ addInsurance: quoteType() != 1 }"
  *ngIf="!showInsurance()"
  (click)="addInsurance()"
  [disabled]="!isValid() || !isValidInsuranceState || hasManualInsurance()"
  tabindex="52"
>
  {{ quoteType() == 1 ? 'Agregar seguro broker' : 'Agregar seguro' }}
</button>

<div id="insuranceEditDesktop" *ngIf="showInsurance()" [ngClass]="{ openQuote: quoteType() == 1 }">
  <div class="title">
    <h3>Seguro</h3>
    <div class="actions">
      <a
        class="delete"
        tp="Eliminar seguro"
        (click)="deleteInsurance()"
        (keydown.enter)="deleteInsurance()"
        tabindex="53"
        >Eliminar</a
      >
    </div>
  </div>
  <form action="" [formGroup]="formInsurance ? formInsurance : form">
    <div class="wrapperG5">
      <div class="selectWrapper">
        <label for="">Tipo de seguro<span class="required">*</span></label>
        <div class="customSelect">
          <select name="" id="" formControlName="insuranceType" tabindex="54">
            @for(insuranceTypes of insuranceService.insuranceList; track insuranceTypes.value){
            <option
              *ngIf="insuranceTypes.isActive?.(typeInsuranceParams)"
              [value]="insuranceTypes.value"
              [hidden]="insuranceTypes.value == null"
            >
              {{ insuranceTypes.description }}
            </option>
            }
          </select>
        </div>
      </div>
      <div class="selectWrapper">
        <label for="">Estado<span class="required">*</span></label>
        <div class="customSelect">
          <select
            name=""
            id=""
            [attr.data-selected]="stateId"
            formControlName="stateId"
            tabindex="55"
          >
            @for(state of states(); track state.stateId){
            <option [value]="state.stateId">
              {{ state.state }}
            </option>
            }
          </select>
        </div>
      </div>
      @if(notIsTruckAndTracts){
      <div class="selectWrapper">
        <!-- (ngModelChange)="getUdis()" -->
        <label for="">Uso<span class="required">*</span></label>
        <div class="customSelect">
          <select
            name=""
            id=""
            formControlName="vehicleServiceType"
            tabindex="56"
          >
            <option *ngFor="let use of useList" [value]="use.value">
              {{ use.description }}
            </option>
          </select>
        </div>
      </div>
      }

      <ng-container *ngIf="insuranceService.insuranceModel()?.modelType == modelEnum.autobuses">
        <!--
        <div class="inputWrapper" style="overflow: visible" *ngIf="formInsurance">
          <label for="">Código postal</label>
          <app-input-search
            [selectedModel]="formInsurance.controls['postalCode'].value"
            [options]="postalCodeList()"
            placeholder="Buscar código postal"
            (searchSelected)="selectedPostalCode($event)"
          >
          </app-input-search>
        </div>
        -->
        <div class="inputWrapper">
          <label for="">Cantidad de pasajeros<span class="required">*</span></label>
          <div class="inputAndNote">
            <input
              type="number"
              id="quantityPassengersInput"
              (blur)="calculatePassenger($event)"
              formControlName="quantityPassengers"
              class="size1"
              tabindex="57"
            />
            <div class="rango">
              <span class="note">Min {{ minPassenger }} / Max {{ maxPassenger }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      @if(isTruckAndTracts){
      <div class="selectWrapper">
        <label for="">Tipo de carga</label>
        <div class="customSelect size1">
          <select name="" id="" formControlName="loadType" tabindex="58">
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
          </select>
        </div>
      </div>
      } @if(isTracts){
      <div class="inputWrapper">
        <label for="">Número de remolques</label>
        <div class="wrapperRemolques">
          <input
            type="number"
            id="quantityTrailers"
            formControlName="quantityTrailers"
            (blur)="onChangeQuantity()"
            class="size1"
            tabindex="59"
          />
          <div class="rango">
            <span class="note">Min {{ minTrailers }} / Max {{ maxTrailers }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </form>
  <div class="actionsWrapper">
    <button
      (click)="openInsuranceFlexModal()"
      [disabled]="!isValidInsurance || !isModelValid()"
      [ngClass]="{ tertiary: quoteType() == 1, secondary: quoteType() != 1 }"
      tabindex="60"
    >
      Cotizar seguro
    </button>
  </div>
</div>

<ng-template #insuranceModalFlex>
  <app-insurance-flex
    [insurance]="formInsurance?.getRawValue()"
    [dealerBranch]="dealerBranch"
    (closed)="closeFlexModal($event)"
  />
</ng-template>

<ng-template #modalConfirmation>
  <app-template-confirmation
    [title]="confirmationData().title"
    [subtitle]="confirmationData().subtitle"
    [btn1]="confirmationData().btn1"
    [btn2]="confirmationData().btn2"
    (closeModal)="closeConfirmationModal()"
    (actionBtn2)="editInsurance()"
  ></app-template-confirmation>
</ng-template>

<ng-template #insuranceSensitiveModal>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="cancelInsuranceSensitiveEdit()">Cerrar</a>
    <h1>Eliminar propuestas</h1>
    <p>
      Está editando datos sensibles, si continúa con los cambios la propuesta de seguro será eliminada.
    </p>
    <div class="modalActions index">
      <button type="button" (click)="cancelInsuranceSensitiveEdit()" class="secondary">Cancelar</button>
      <button type="button" (click)="confirmInsuranceSensitiveEdit()" class="primary">Eliminar</button>
    </div>
  </div>
</ng-template>
